import { Component, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FiltroRisco } from 'src/app/models/filtro-risco.model';
import { CriteriosAvaliacaoRiscoService } from 'src/app/services/criterios-avaliacao-risco.service';
import { RiscosChavesServices } from 'src/app/services/riscos-chaves.service';
import { RiscosService } from 'src/app/services/riscos.service';
import { BaseListComponent } from 'src/app/shared/components/base-list/base-list.component';
import { SharedService } from 'src/app/services/shared.service';
import { ModalSelecaoRiscoComponent } from '../modal-selecao-risco/modal-selecao-risco.component';
import { ActivatedRoute } from '@angular/router';
import { IRiscosChavesProcessoItemModel } from 'src/app/models/riscos-chaves.model';
import { IMaginitudesEscalaRisco } from 'src/app/models/maginitudes-escala-risco.model';
import { ICriteriosAvaliacaoRiscos } from 'src/app/models/criterios-avaliacao-riscos.model';
import { MatTableDataSource } from '@angular/material/table';
import { EscalasService } from 'src/app/services/escalas.service';
import { NiveisRiscoInerenteService } from 'src/app/services/niveis-risco-inerente.service';
import { NiveisRiscoResidualService } from 'src/app/services/niveis-risco-residual.service';
import { ControleService } from 'src/app/services/controle.service';
import { event } from 'jquery';



@Component({
  selector: 'app-preenchimento-riscos-criterios',
  templateUrl: './preenchimento-riscos-criterios.component.html',
  styleUrls: ['./preenchimento-riscos-criterios.component.scss']
})
export class PreenchimentoRiscosCriteriosComponent extends BaseListComponent implements OnInit {

  public filtro =  {} as FiltroRisco;
  public modelRiscosChavesProcessoItem: IRiscosChavesProcessoItemModel = {} as IRiscosChavesProcessoItemModel;
  public modelCriterioAvaliacaoRisco: ICriteriosAvaliacaoRiscos = {} as ICriteriosAvaliacaoRiscos;
  public dataSource = new MatTableDataSource<IRiscosChavesProcessoItemModel>([]);
  public valorTotalRI: number = 0;
  public valorTotalRR: number = 0;
  public riscoControle: string;
  public nomeRisco: string;
  public valor1: string;
  public valor2: string;
  public operador: string;
  id: number;
  processoId: number;
  displayedColumnDescricao: string[] = ['descricao'];
  displayedColumnEscalas: string[] = [];
  displayedColumns: string[] = ['ri', 'nivelRisco', 'situacao', 'riscoControle', 'rr', 'nivelRiscoResidual', 'acoes']
  valorRI: number;
  valorXpto: number;
  valorProbabilidade: number;
  riscos: any[] = [
    { escalasCriterioAvaliacao: [], escala1: null, escala2: null, escala3: null, escala4: null }    
  ];

  constructor(private riscosChavesService: RiscosChavesServices,
              private riscosService: RiscosService,              
              private criteriosAvaliacaoService: CriteriosAvaliacaoRiscoService,
              private sharedService: SharedService,
              private matDialog: MatDialog,
              private route: ActivatedRoute,
              private nivelRiscoResidualService: NiveisRiscoResidualService,
              private nivelRiscoInerenteService: NiveisRiscoInerenteService,
              private controleService: ControleService
  ) 
  { 
    super();    
  }

  async ngOnInit() {
   
    this.id = parseInt(this.route.snapshot.paramMap.get('id'));
    this.processoId = parseInt(this.route.snapshot.paramMap.get('processoId'));
    await this.riscosChavesService.obterPorId(this.id)
    this.obterDescricaoRisco();
    
  }

  excluirRisco(index: number) {

    this.riscosChavesService
      .excluirProcesso(index)
      .then((res) => {
        if (res.sucesso) {
          this.exibirMensagemSucesso('Risco excluído com sucesso.');
        } else {
          this.exibirMensagemAlerta(res.mensagem.descricao);
        }
      })
      .catch((err) => {
        this.exibirMensagemErro(err.mensagem);
      })
      .finally(() => {
        this.obterDescricaoRisco();
      });
  }

  public obterDescricaoRisco() {
    
    this.riscosChavesService
      .obterItensProcesso(this.id,this.processoId)
      .then((res) => {
        
        if (res.dados.length>0){
          if(res.dados[0].dadosFormulaRiscoInerente.length>0 ){
            this.verificaFormula(res.dados[0].dadosFormulaRiscoInerente);
          }
            
        }
        
        this.dataSource = new MatTableDataSource<IRiscosChavesProcessoItemModel>(res.dados);    
  
        this.obterEscalas();
        this.inicializarValoresPadrao();
 
      })
      .catch((err) => {
        this.exibirMensagemErro(err.mensagem);
      })
  }


  public inicializarValoresPadrao() 
  {
    let indice = 0;
    this.displayedColumnEscalas.forEach(escala => {
      this.dataSource.data.forEach(risco => {
        const escalaEncontrada = risco.escalasCriterioAvaliacao.find(esc => esc.nome === escala);

        if (indice == 0)
        {
          if (escalaEncontrada && escalaEncontrada.magnitudeEscala.length > 0) 
          {
            // Se `risco.magnitude_nome` já tem um valor correspondente, usa ele. Senão, define o primeiro da lista
            const valorExistente = escalaEncontrada.magnitudeEscala.find(mag => mag.magnitude === risco.magnitude_1Nome);
            risco[escala] = valorExistente;
           
          }
        }
        else if (indice == 1)
        {
          const valorExistente = escalaEncontrada.magnitudeEscala.find(mag => mag.magnitude === risco.magnitude_2Nome);
          risco[escala] = valorExistente;
        }
        else if (indice == 2)
        {
          const valorExistente = escalaEncontrada.magnitudeEscala.find(mag => mag.magnitude === risco.magnitude_3Nome);
          risco[escala] = valorExistente;
        }
      });
      indice++;
      
    });
    if (this.displayedColumns.includes('situacao')) {
      this.dataSource.data.forEach(risco => {
       
        if (risco.situacaoId) {
          const avaliacaoSelecionada = risco.situacaoSelecionada;
        }
        console.log(risco)
      });
    
      this.dataSource._updateChangeSubscription(); // Atualiza a tabela
    }
    
    
   
    
  }
  
  public buscarRisco(){
    
		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = 'modal-component';
		dialogConfig.width = '650px';
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = true;

    const modal = this.matDialog.open(ModalSelecaoRiscoComponent , dialogConfig );
    modal.afterClosed().subscribe((data) => {
      if(data){
        this.filtro.pesquisa = data.id;
        this.adicionarRisco(data.id);      
      }
    })
	}

  public async adicionarRisco(riscoId: number){
    try {
      
     const result = await (await this.riscosService.obterPorId(riscoId)).dados;
     this.nomeRisco = result.nome;
      if (this.id) {
        const res = await this.riscosChavesService.obterPorId(this.id).then((res)=>{
          this.modelRiscosChavesProcessoItem.riscoChaveId = res.dados.id;
          this.modelRiscosChavesProcessoItem.criterioAvaliacaoId = res.dados.criterioAvaliacaoId;
          this.modelRiscosChavesProcessoItem.riscoId = riscoId;
          this.modelRiscosChavesProcessoItem.processoId = this.processoId;
          this.modelRiscosChavesProcessoItem.nomeRisco = this.nomeRisco;          
        })
      const inserir = await this.riscosChavesService.inserirProcessoItem(this.modelRiscosChavesProcessoItem);
      if(inserir.sucesso)
        location.reload();
      }
    } catch (error) {
      console.error("Erro inesperado ao inserir o risco no processo!:", error);
    }

  }

  public obterEscalas() {

    if (this.dataSource.data.length > 0) {
      this.displayedColumnEscalas = this.dataSource.data[0].escalasCriterioAvaliacao.map(e => e.nome);
    }
  }

  selecionarItem(risco: IRiscosChavesProcessoItemModel, escala: string, event: any) 
  {  

    if (!risco.magnitudeEscalaRisco) 
      {
        risco.magnitudeEscalaRisco = [];
      } 

    const magnitudeSelecionada = event.value;
    let existeMagnitude = false;

    for(var i = 0; i < risco.magnitudeEscalaRisco.length; i++ ){
      if(risco.magnitudeEscalaRisco[i].escalasId == event.value.escalasId){
        risco.magnitudeEscalaRisco[i] = magnitudeSelecionada;
        existeMagnitude = true;
        break;        
      }   
    }

    if (!existeMagnitude)
      risco.magnitudeEscalaRisco.push(event.value);

  }
  selecionarAvaliacao(risco: IRiscosChavesProcessoItemModel, event: any) {
    
    const avaliacaoSelecionada = risco.riscoControle.find(controle => controle.id === (Number(controle.id)));
    this.riscoControle = avaliacaoSelecionada.valorDoRisco;
    risco.situacaoId = avaliacaoSelecionada.id;
    risco.riscoControleRR = parseFloat(this.riscoControle.toString().replace(',', '.'));
    risco.situacaoSelecionada = avaliacaoSelecionada.avaliacao;
   
  }

  public verificaFormula(dadosFormula: any[])
  {    
    if (dadosFormula)
      {
        this.valor1 = dadosFormula[0].campo;
        this.valor2 = dadosFormula[1].campo;
        
        for(var i = 0; i<dadosFormula.length; i++ )
          {
            if(dadosFormula[i].operador != "" && dadosFormula[i].operador != null)
              {
                this.operador = dadosFormula[i].operador
              }
          }
      }
  }
  

  public async salvarDados(salvarEFechar: boolean){   
  
    for( var i = 0; i < this.dataSource.data.length; i++ )
      {        
        await this.riscosChavesService.atualizarProcesso(this.dataSource.data[i]);
      }
  }

  public calcularRI(risco: IRiscosChavesProcessoItemModel)
  { 

    const operador = this.operador; // Operação dinâmica
    if (risco.magnitudeEscalaRisco.length > 0)
    {
      const valores = risco.magnitudeEscalaRisco.map(item => item.valor);

      let resultado = valores[0];

      for (let i = 1; i < valores.length; i++) 
      {
        switch (this.operador) {
            case '+':
                resultado += valores[i];
                break;
            case '-':
                resultado -= valores[i];
                break;
            case '*':
                resultado *= valores[i];
                break;
            case '/':
                if (valores[i] !== 0) {
                    resultado /= valores[i];
                } else {
                    console.warn("Divisão por zero não permitida!");
                }
                break;
            default:
                console.warn(`Operador "${this.operador}" não reconhecido!`);
                return;
        }
      }

      risco.ri = resultado;
      
      this.nivelRiscoInerenteService
      .obter(String(risco.criterioAvaliacaoId),true)
      .then((res) => {

        for(var i = 0; i < res.dados.length; i++ )
          {
            let condicao = this.verificarCondicaoRI(Number(risco.ri), 
            res.dados[i].operador, 
            Number(res.dados[i].valor),
            res.dados[i].operador_1,
            Number(res.dados[i].valor_1))
            
            if (condicao)
            {
              risco.nivelRiscoRINome = res.dados[i].nome;
              risco.idNomeNivelRisco = res.dados[i].id;
              break;
            }            
          }
      })
      .catch((err) => {
        this.exibirMensagemErro(err.mensagem);
      })
    }
  }

  public calcularRR(risco: IRiscosChavesProcessoItemModel) { 

    const formula = risco.dadosFormulaRiscoResidual;

    let operador = formula.operador; 
    let campo1 = formula.campo_1;
    let campo2 = formula.campo_2;

    // Substituindo os campos pelo valor numérico correspondente
    switch (campo1) {
        case 'Valor do Risco Inerente':
            campo1 = String(risco.ri);
            break;
        case 'Risco do Controle':
            campo1 = this.riscoControle;
            break;
    }

    switch (campo2) {
        case 'Valor do Risco Inerente':
            campo2 = String(risco.ri);
            break;
        case 'Risco do Controle':
            campo2 = this.riscoControle;
            break;
    }

    let valor1 = parseFloat(campo1.toString().replace(',', '.'));
    let valor2 = parseFloat(campo2.toString().replace(',', '.'));

    if (isNaN(valor1) || isNaN(valor2)) {
        console.error("Erro: Um dos valores não é um número válido!", { valor1, valor2 });
        return;
    }

    let resultado = 0;

    switch (operador) {
        case '+':
            resultado = valor1 + valor2;
            break;
        case '-':
            resultado = valor1 - valor2;
            break;
        case '*':
            resultado = valor1 * valor2;
            break;
        case '/':
            if(valor1 !== 0 || valor2 !== 0){
                resultado = valor1/valor2;
                break;
            }
            else {
              console.warn("Divisão por zero não permitida!");
            }   
          default:
            console.error(`Erro: Operador "${operador}" não reconhecido!`);
            return;
    }
   
    this.nivelRiscoResidualService
      .obter(String(risco.criterioAvaliacaoId),true)
      .then((res) => {

        for(var i = 0; i < res.dados.length; i++ )
          {
            let condicao = this.verificarCondicaoRI(Number(risco.rr), 
            res.dados[i].operador, 
            Number(res.dados[i].valor),
            res.dados[i].operador_1,
            Number(res.dados[i].valor_1))
            
            if (condicao)
            {
              risco.nivelRiscoRRNome = res.dados[i].nome;
              risco.idNomeNivelRiscoRR = res.dados[i].id;
              break;
            }            
          }
      })
      .catch((err) => {
        this.exibirMensagemErro(err.mensagem);
      })
    // 🔹 Salvando o resultado no risco
    risco.rr = resultado;
}


  verificarCondicaoRI(valorRI: number, operador: string, valor: number, operador_1: string, valor_1: number): boolean 
  {
    let condicao1 = false;
    let condicao2 = false;

    // Verificar a primeira condição (variavel > valor)
    if ((operador === '>' || operador === '<' || operador === '!=' || operador === '=' || operador === '>='|| operador === '<=') && valorRI > valor) {
      condicao1 = true;
    }

    // Verificar a segunda condição (variavel < valor_1)
    if ((operador === '>' || operador === '<' || operador === '!=' || operador === '=' || operador === '>='|| operador === '<=') && valorRI < valor_1) {
      condicao2 = true;
    }

    // Verificar se ambas as condições são verdadeiras
    return condicao1 && condicao2;
  }

  public calcularMagnitude(){
    
    for( var i = 0; i < this.dataSource.data.length; i++ )
      {    
        if (this.dataSource.data[i].ri)    
          this.valorTotalRI += this.dataSource.data[i].ri;
          this.valorTotalRR += this.dataSource.data[i].rr;

      }

  }

}

